<mat-grid-list cols="4" rowHeight="fit" [style]="heightStyle">
  <mat-grid-tile class="document-viewer" colspan="3">
    <!-- Canvas Viewer -->
    <app-capture-viewer *ngIf="isCanvas === true" (heightChanged)="heightChanged($event)"
                        class="capture-document-canvas"></app-capture-viewer>

    <!-- PDF Viewer -->
    <div *ngIf="isCanvas === false" #documentViewer class="document-viewer">
      <pdf-viewer
        *ngIf="pdfsrc !== undefined; else imageViewer"
        [src]="pdfsrc"
        [page]="currentPdfPage"
        [autoresize]="true"
        [original-size]="false"
        [render-text]="true"
        (after-load-complete)="onPdfLoaded($event)"
        (pageChange)="onPdfPageChange($event)"
        style="width: 100%; height: 100%;">
      </pdf-viewer>

      <ng-template #imageViewer>
        <canvas #canvas></canvas>
      </ng-template>
    </div>
  </mat-grid-tile>

  <mat-grid-tile colspan="1">
    <app-capture-form
      class="capture-document-form"
      [totalPages]="totalPages"
      [selectedPageForOcr]="selectedPageForOcr"
      [pdfPageNumbers]="pdfPageNumbers"
      [ocrInProgress]="ocrInProgress"
      [availablePages]="availableOcredPages"
      (pageSelected)="onPageSelected($event)"
      (ocrRequested)="requestOcrForSelectedPage()">
    </app-capture-form>
  </mat-grid-tile>
</mat-grid-list>
